import { delay, http, HttpResponse } from 'msw'

import { days } from './data'

let counter = '0'
export const handlers = [
  http.get('*/daily-check-in', async () => {
    const aux = parseInt(counter, 10) + 1
    counter = aux.toString()
    await delay(500)

    return HttpResponse.json({
      id: 'LOYALTY_DAILY_CHECK_IN_HOME',
      title: 'Check-in premiado',
      cacheTimeSeconds: 300,
      sections: [
        {
          showDataCache: true,
          unavailabilityMessage: 'Função indisponível no momento. Tente novamente em breve.',
          content: [
            {
              sectionTitle: 'Novidades do Dia',
              sectionItems: [
                {
                  label: 'Pague com Pontos Loop',
                  title: 'Gift Cards',
                  description: 'Compre e receba cashback!',
                  deeplink: '',
                  icon: 'gift',
                  backgroundColor: '--auxiliary-raspberry-100',
                },
                {
                  label: 'Muito Cashback',
                  title: 'Ofertas do Dia',
                  description: 'Produtos do Shopping com muito desconto e até 20% de cashback.',
                  deeplink: 'INTER_SHOP',
                  icon: 'bag',
                  backgroundColor: '--primary100',
                },
                {
                  label: 'Comece agora',
                  title: 'Oportunidades do dia',
                  description: 'Investimentos de forma fácil e rápida.',
                  deeplink: '',
                  icon: 'safe',
                  backgroundColor: '--auxiliary-avocado-100',
                },
                {
                  label: 'Condições Especiais',
                  title: 'Empréstimos',
                  description: 'Alivie dívidas, financie bens e antecipe seu FGTS.',
                  deeplink: '',
                  icon: 'wallet',
                  backgroundColor: '--auxiliary-pitaya-100',
                },
              ],
            },
          ],
          id: 'LOYALTY_DAILY_CHECK_IN_DAILY_NEWS_WIDGET',
          status: 'ATIVA',
        },
        {
          showDataCache: true,
          unavailabilityMessage: 'Função indisponível no momento. Tente novamente em breve.',
          content: [
            {
              sectionTitle: 'Erro ao fazer o check-in',
              sectionItems: [
                {
                  icon: 'alert',
                  title: 'Houve um erro por aqui.',
                  description:
                    'No momento não é possível registrar o seu check-in. Tente novamente mais tarde.',
                  button: {
                    text: 'Voltar',
                    deeplink: 'CLOSE',
                  },
                },
              ],
            },
          ],
          id: 'LOYALTY_DAILY_CHECK_IN_ERROR_WIDGET',
          status: 'ATIVA',
        },
        // {
        //   showDataCache: true,
        //   unavailabilityMessage: 'Função indisponível no momento. Tente novamente em breve.',
        //   content: [
        //     {
        //       sectionTitle: 'Erro ao fazer o check-in',
        //       sectionItems: [
        //         {
        //           icon: 'alert',
        //           title: 'Houve um erro por aqui.',
        //           description:
        //             'No momento não é possível acessar essa página. Você pode tentar novamente mais tarde.',
        //           button: {
        //             text: 'Voltar',
        //             deeplink: 'BACK',
        //           },
        //         },
        //       ],
        //     },
        //   ],
        //   id: 'LOYALTY_DAILY_CHECK_IN_GET_ERROR_WIDGET',
        //   status: 'ATIVA',
        // },
        {
          showDataCache: true,
          unavailabilityMessage: 'Função indisponível no momento. Tente novamente em breve.',
          content: [
            {
              sectionTitle: 'Faça seu check-in',
              sectionItems: [
                {
                  header: 'Marque sua presença diariamente e colete recompensas semanalmente!',
                  footer: 'Sua sequência é quebrada se você esquecer de entrar em algum dia.',
                  checkIns: days[counter as keyof typeof days],
                  alert: {
                    icon: 'loop',
                    title: 'Você recebeu 500 pontos Loop',
                    description: 'Seu saldo de pontos será atualizado em breve.',
                    button: {
                      text: 'Trocar',
                      deeplink: 'LOYALTY_REDEEM_POINTS',
                    },
                  },
                },
              ],
            },
          ],
          id: 'LOYALTY_DAILY_CHECK_IN_WIDGET',
          status: 'ATIVA',
        },
      ],
    })
  }),
  http.post('*/daily-check-in', async () => {
    await delay(500)
    return HttpResponse.json({})
  }),
]
